<ng-template #topwarnings>
    <div uppDataid="place-offline-warning" class="topmsg" [hidden]="TopMessage !== 'OFFLINE'">
        <ion-item color="danger" lines="none">
            <ion-spinner slot="start" name="lines-small"></ion-spinner>
            <ion-label>
                {{tr('@offline_warning')}}
            </ion-label>
        </ion-item>
    </div>
    <div uppDataid="user-activation-warning" class="topmsg" [hidden]="TopMessage !== 'USERPENDING'">
        <ion-item color="warning" lines="none" (click)="EditUser()">
            <ion-icon slot="start" name="mail-unread-outline"></ion-icon>
            <ion-label>
                {{tr('@activation_warning')}}
            </ion-label>
        </ion-item>
    </div>
    <div uppDataid="place-waiter-warning" class="topmsg" [hidden]="TopMessage !== 'WAITER'">
        <ion-item color="warning" lines="none" (click)="OnWaiter()">
            <ion-icon slot="start" name="hand-right-outline"></ion-icon>
            <ion-label>
                <span *ngIf="WaiterTables.length === 1">{{tr('@waiter_warning_single', [ WaiterTables[0].number ? WaiterTables[0].number : '' ])}}</span>
                <span *ngIf="WaiterTables.length !== 1">{{tr('@waiter_warning_multiple')}}</span>
            </ion-label>
        </ion-item>
    </div>
    <div uppDataid="place-license-warning" class="topmsg" [hidden]="TopMessage !== 'EXPIRED'">
        <ion-item color="danger" lines="none" (click)="OnExpiredLicense()">
            <ion-icon slot="start" name="alarm-outline"></ion-icon>
            <ion-label>
                {{tr('@warning_place_expired_title')}}
            </ion-label>
        </ion-item>
    </div>
    <div uppDataid="place-license-expiring-warning" class="topmsg" [hidden]="TopMessage !== 'EXPIRING'">
        <ion-item color="warning" lines="none" (click)="OnExpiredLicense()">
            <ion-icon slot="start" name="warning-outline"></ion-icon>
            <ion-label>
                {{tr('@warning_place_expiring_title', [ place?.DaysLeft ])}}
            </ion-label>
        </ion-item>
    </div>
    <div uppDataid="place-service-warning" class="topmsg" [hidden]="TopMessage !== 'NOSERVICE'">
        <ion-item color="danger" lines="none" (click)="OnConfigurePos()">
            <ion-icon slot="start" name="cloud-offline-outline"></ion-icon>
            <ion-label>
                {{tr('@place_service_offline_warning')}}
            </ion-label>
        </ion-item>
    </div>
    <div uppDataid="place-fiscal-warning" class="topmsg" [hidden]="TopMessage !== 'FISCAL'">
        <ion-item color="warning" lines="none" (click)="OnFiscal()">
            <ion-icon slot="start" name="warning-outline"></ion-icon>
            <ion-label>
                {{tr('@warning_place_fiscal_title')}}
            </ion-label>
        </ion-item>
    </div>
    <div uppDataid="place-pos-warning" class="topmsg" [hidden]="TopMessage !== 'NOTPV'">
        <ion-item color="warning" lines="none" (click)="OnConfigurePos()">
            <ion-icon slot="start" name="warning-outline"></ion-icon>
            <ion-label>
                {{tr('@place_pos_warning')}}
            </ion-label>
        </ion-item>
    </div>
    <div uppDataid="place-update-warning" class="topmsg" [hidden]="TopMessage !== 'SWUPDATE'">
        <ion-item color="primary" lines="none" (click)="OnUpdate()">
            <ion-icon slot="start" name="reload-outline"></ion-icon>
            <ion-label>
                {{tr('@swupdate_warning')}}
            </ion-label>
        </ion-item>
    </div>
</ng-template>

<!-- Mobile: full-width strip; hue on icon/label, not a filled chip. -->
<ng-template #topwarningsMobile>
    <div uppDataid="place-offline-warning" class="topmsg" [hidden]="TopMessage !== 'OFFLINE'">
        <ion-item lines="none">
            <ion-spinner color="danger" slot="start" name="lines-small"></ion-spinner>
            <ion-label color="danger">
                {{tr('@offline_warning')}}
            </ion-label>
        </ion-item>
    </div>
    <div uppDataid="user-activation-warning" class="topmsg" [hidden]="TopMessage !== 'USERPENDING'">
        <ion-item lines="none" (click)="EditUser()">
            <ion-icon color="warning" slot="start" name="mail-unread-outline"></ion-icon>
            <ion-label color="warning">
                {{tr('@activation_warning')}}
            </ion-label>
        </ion-item>
    </div>
    <div uppDataid="place-waiter-warning" class="topmsg" [hidden]="TopMessage !== 'WAITER'">
        <ion-item lines="none" (click)="OnWaiter()">
            <ion-icon color="warning" slot="start" name="hand-right-outline"></ion-icon>
            <ion-label color="warning">
                <span *ngIf="WaiterTables.length === 1">{{tr('@waiter_warning_single', [ WaiterTables[0].number ? WaiterTables[0].number : '' ])}}</span>
                <span *ngIf="WaiterTables.length !== 1">{{tr('@waiter_warning_multiple')}}</span>
            </ion-label>
        </ion-item>
    </div>
    <div uppDataid="place-license-warning" class="topmsg" [hidden]="TopMessage !== 'EXPIRED'">
        <ion-item lines="none" (click)="OnExpiredLicense()">
            <ion-icon color="danger" slot="start" name="alarm-outline"></ion-icon>
            <ion-label color="danger">
                {{tr('@warning_place_expired_title')}}
            </ion-label>
        </ion-item>
    </div>
    <div uppDataid="place-license-expiring-warning" class="topmsg" [hidden]="TopMessage !== 'EXPIRING'">
        <ion-item lines="none" (click)="OnExpiredLicense()">
            <ion-icon color="warning" slot="start" name="warning-outline"></ion-icon>
            <ion-label color="warning">
                {{tr('@warning_place_expiring_title', [ place?.DaysLeft ])}}
            </ion-label>
        </ion-item>
    </div>
    <div uppDataid="place-service-warning" class="topmsg" [hidden]="TopMessage !== 'NOSERVICE'">
        <ion-item lines="none" (click)="OnConfigurePos()">
            <ion-icon color="danger" slot="start" name="cloud-offline-outline"></ion-icon>
            <ion-label color="danger">
                {{tr('@place_service_offline_warning')}}
            </ion-label>
        </ion-item>
    </div>
    <div uppDataid="place-fiscal-warning" class="topmsg" [hidden]="TopMessage !== 'FISCAL'">
        <ion-item lines="none" (click)="OnFiscal()">
            <ion-icon color="warning" slot="start" name="warning-outline"></ion-icon>
            <ion-label color="warning">
                {{tr('@warning_place_fiscal_title')}}
            </ion-label>
        </ion-item>
    </div>
    <div uppDataid="place-pos-warning" class="topmsg" [hidden]="TopMessage !== 'NOTPV'">
        <ion-item lines="none" (click)="OnConfigurePos()">
            <ion-icon color="warning" slot="start" name="warning-outline"></ion-icon>
            <ion-label color="warning">
                {{tr('@place_pos_warning')}}
            </ion-label>
        </ion-item>
    </div>
    <div uppDataid="place-update-warning" class="topmsg" [hidden]="TopMessage !== 'SWUPDATE'">
        <ion-item lines="none" (click)="OnUpdate()">
            <ion-icon color="primary" slot="start" name="reload-outline"></ion-icon>
            <ion-label color="primary">
                {{tr('@swupdate_warning')}}
            </ion-label>
        </ion-item>
    </div>
</ng-template>

<ng-template #topactions>
    <!-- Clock only with an active place on desktop (select-place never shows it; phone OS already has the time). -->
    <ion-label *ngIf="view.Desktop && place !== null" class="clock" slot="end">
        {{Clock.Hours}}<span class="small">:</span>{{Clock.Minutes}}
    </ion-label>
    <ion-buttons slot="end">
        <ion-button uppDataid="place-close-button" (click)="OnClose()">
            <ion-icon color="dark" slot="icon-only" icon="exit-outline"></ion-icon>
        </ion-button>
    </ion-buttons>
</ng-template>

<ng-template #userview>
    <div class="user-chrome">
        <div class="img-box">
            <upp-image uppDataid="user-edit-button" [src]="user?.photo || 'assets/image/profile.png'" (click)="EditUser()"></upp-image>
        </div>
        <ion-toolbar class="user">
            <ion-title *ngIf="place === null">
                {{tr('@main_select_place')}}
            </ion-title>
            <ng-container [ngTemplateOutlet]="topactions"></ng-container>
        </ion-toolbar>
    </div>
</ng-template>

<ng-template #placeview>
    <ion-toolbar class="place">
        <ion-buttons slot="start">
            <ion-menu-button uppDataid="main-menu-button" color="dark" auto-hide="true"></ion-menu-button>
        </ion-buttons>
        <ion-title *ngIf="place !== null">
            {{place.name || tr('@place_no_name')}}
        </ion-title>
        <ng-container [ngTemplateOutlet]="topactions"></ng-container>
    </ion-toolbar>
</ng-template>

<ng-container *ngIf="user !== null">
    <!-- Desktop: toolbar first; absolute chips as siblings outside the toolbar. -->
    <ng-container *ngIf="view.Desktop === true">
        <div class="chrome desktop">
            <ng-container *ngIf="place === null">
                <ng-container [ngTemplateOutlet]="userview"></ng-container>
            </ng-container>
            <ng-container *ngIf="place !== null">
                <ng-container [ngTemplateOutlet]="placeview"></ng-container>
            </ng-container>
            <ng-container [ngTemplateOutlet]="topwarnings"></ng-container>
        </div>
    </ng-container>

    <!-- Mobile: full-width strip above the bar; never absolute chips in the toolbar row. -->
    <ng-container *ngIf="view.Desktop !== true">
        <div class="chrome mobile">
            <ng-container [ngTemplateOutlet]="topwarningsMobile"></ng-container>
            <ng-container *ngIf="place === null">
                <ng-container [ngTemplateOutlet]="userview"></ng-container>
            </ng-container>
        </div>
    </ng-container>
    <ion-progress-bar uppDataid="place-loading-progress" [hidden]="view.Mobile && !IsLoading" color="warning" [value]="LoadPercent"></ion-progress-bar>
</ng-container>
